export default {
  jp: {
    title: '登録情報変更',
    label: {
      id: 'ID（メールアドレス）',
      password: 'パスワード',
      name: '氏名',
      group: '所属',
      company: '会社',
      branch: '支社・支局または媒体',
      postNo: '郵便番号',
      prefCd: '都道府県',
      addr1: '市区町村',
      addr2: '番地',
      addr3: 'ビル名',
      busho: '部署',
      telNo: '電話番号',
      remarks: '備考',
      services: '利用希望サービス'
    },
    ph: {
      id: 'メールアドレスを入力してください',
      password: 'パスワードを変更する場合は入力してください',
      passwordConfirm: 'パスワードを変更する場合は入力してください（確認用）',
      name: '氏名を入力してください',
      groupSmall: '選択してください',
      company: '選択してください',
      companyName: '「その他」を選択した場合に会社名を入力してください',
      companyNameKana: '「その他」を選択した場合に会社名（カナ）入力してください',
      branch: '##BRANCH_LABEL##がある場合は選択してください',
      branchName: '「その他」を選択した場合に##BRANCH_LABEL##名を入力してください',
      branchNameKana: '「その他」を選択した場合に##BRANCH_LABEL##名（カナ）を入力してください',
      postNo: '郵便番号を入力してください',
      prefCd: '選択してください',
      addr1: '市区町村を入力してください',
      addr2: '番地を入力してください',
      addr3: 'ビル名を入力してください',
      busho: '部署を入力してください',
      telNo: '携帯番号、部署番号を入力してください',
      remarks: '備考を入力してください'
    },
    error: {
      accountId: {
        notExistsGroupAdmin: '他にグループ責任者が存在しないため、設定を変更をすることができません。他のアカウントをグループ責任者に変更のうえ、処理を実施するようお願いいたします。'
      },
      id: {
        isDuplicated: '入力されたIDはすでに使用済みになります。別のIDを入力してください。'
      },
      mailAddress: {
        required: 'IDは入力必須項目です。',
        maxLength: 'IDは100文字以内で入力してください。',
        invalid: 'IDの書式に誤りがあります。'
      },
      password: {
        maxLength: 'パスワードは8文字から100文字以内で入力してください。',
        invalidPolicy: '入力したパスワードはパスワードポリシーの要件を満たしていません。'
      },
      passwordConfirm: {
        maxLength: 'パスワード（確認用）は8文字から100文字以内で入力してください。',
        notEqualsPassword: 'パスワードとパスワード（確認用）の入力内容が一致しておりません。'
      },
      name: {
        required: '氏名は入力必須項目です。',
        maxLength: '氏名は50文字以内で入力してください。'
      },
      groupLargeId: {
        required: '所属（大分類）が設定されていません。',
        invalid: '所属（大分類）の入力内容に不備があります。'
      },
      groupSmallId: {
        required: '所属（小分類）が設定されていません。',
        invalid: '所属（小分類）の入力内容に不備があります。'
      },
      companyId: {
        required: '##COMPANY_LABEL##が設定されていません。',
        invalid: '##COMPANY_LABEL##の入力内容に不備があります。'
      },
      branchId: {
        required: '##BRANCH_LABEL##は入力必須項目です。',
        invalid: '##BRANCH_LABEL##の入力内容に不備があります。'
      },
      branchName: {
        required: '##BRANCH_LABEL##名は入力必須項目です。',
        maxLength: '##BRANCH_LABEL##名は100文字以内で入力してください。'
      },
      branchNameKana: {
        required: '##BRANCH_LABEL##名（カナ）は入力必須項目です。',
        maxLength: '##BRANCH_LABEL##名（カナ）は100文字以内で入力してください。',
        invalid: '##BRANCH_LABEL##名（カナ）は全角カナ、・、－で入力してください。'
      },
      postNo: {
        required: '郵便番号は入力必須項目です。',
        maxLength: '郵便番号は20文字以内で入力してください。'
      },
      prefCd: {
        required: '都道府県は入力必須項目です。',
        maxLength: '都道府県の入力内容に不備があります。'
      },
      addr1: {
        required: '市区町村は入力必須項目です。',
        maxLength: '市区町村は100文字以内で入力してください。'
      },
      addr2: {
        required: '番地は入力必須項目です。',
        maxLength: '番地は100文字以内で入力してください。'
      },
      addr3: {
        maxLength: 'ビル名は100文字以内で入力してください。'
      },
      busho: {
        required: '部署は入力必須項目です。',
        maxLength: '部署は100文字以内で入力してください。'
      },
      telNo: {
        required: '電話番号は入力必須項目です。',
        maxLength: '電話番号は20文字以内で入力してください。'
      },
      remarks: {
        maxLength: '備考は20000文字以内で入力してください。'
      },
      services: {
        required: '利用希望サービスを選択してください。'
      },
      serviceApplication: {
        exitsUnderJudegeWait: '審査中の利用希望サービスは選択できません。'
      }
    },
    select: {
      other: 'その他'
    },
    button: {
      change: '変更'
    },
    desc: {
      text1: 'は必須項目です。',
      passwordText1: '・8文字以上であること',
      passwordText2: '・半角の英大文字／英小文字／数字／記号のうち、2種類以上の文字種を組み合わせていること',
      serviceText: '・新たに利用希望サービスを追加した場合は、管理者の承認後に利用可能となります。'
    }
  },
  en: {
    title: 'Change Registration Information',
    label: {
      id: 'ID (Email Address)',
      password: 'Password',
      name: 'Name',
      group: 'Group',
      company: 'Company/Organization',
      branch: 'Branch',
      postNo: 'Postal code',
      prefCd: 'Prefecture',
      addr1: 'City',
      addr2: 'Street house number',
      addr3: 'Building Name',
      busho: 'Department',
      telNo: 'Phone number',
      remarks: 'Remarks',
      services: 'Services requested'
    },
    ph: {
      id: 'Enter your email address',
      password: 'Enter to change password.',
      passwordConfirm: 'Enter to confirm password.',
      company: 'Select',
      name: 'Enter your name',
      groupSmall: 'Select',
      companyName: 'Enter your ##COMPANY_LABEL## name if you select "Other".',
      companyNameKana: '',
      branch: 'Select if you have a ##BRANCH_LABEL##.',
      branchName: 'Enter your ##BRANCH_LABEL## name if you select "Other".',
      branchNameKana: '',
      postNo: 'Enter postal code',
      prefCd: 'Select',
      addr1: 'Enter city',
      addr2: 'Enter street house number',
      addr3: 'Enter building name',
      busho: 'Enter department',
      telNo: 'Enter phone number',
      remarks: 'Enter remarks'
    },
    error: {
      accountId: {
        notExistsGroupAdmin: 'You are unable to change the settings because there is no other Group Manager. Please change the other account to Group Manager to process.'
      },
      id: {
        isDuplicated: 'The ID is already in use. Please enter a different ID.'
      },
      mailAddress: {
        required: 'ID is required.',
        maxLength: 'ID must be within 100 characters.',
        invalid: 'There is an error in the format (ID).'
      },
      password: {
        maxLength: 'Password must be 8-100 characters in length.',
        invalidPolicy: 'Password does not meet the requirements.'
      },
      passwordConfirm: {
        maxLength: 'The password must be between 8 and 100 characters long.',
        notEqualsPassword: 'Password and confirm password does not match.'
      },
      name: {
        required: 'Name is required.',
        maxLength: 'Name must be within 50 characters.'
      },
      groupLargeId: {
        required: 'Category is required.',
        invalid: 'Incomplete (Category)'
      },
      groupSmallId: {
        required: 'Subcategory is required.',
        invalid: 'Incomplete (Subcategory)'
      },
      companyId: {
        required: '##COMPANY_LABEL## is required.',
        invalid: 'Incomplete (##COMPANY_LABEL##)'
      },
      branchId: {
        required: '##BRANCH_LABEL## is required.',
        invalid: 'Incomplete (##BRANCH_LABEL##)'
      },
      branchName: {
        required: 'Enter your ##BRANCH_LABEL## name if you select "Other".',
        maxLength: '##BRANCH_LABEL## name must be within 100 characters.'
      },
      postNo: {
        required: 'Postal code is required.',
        maxLength: 'Postal code must be within 20 characters.'
      },
      prefCd: {
        required: 'Prefecture is required.',
        maxLength: 'Incomplete (Prefecture)'
      },
      addr1: {
        required: 'City is required.',
        maxLength: 'City must be within 100 characters.'
      },
      addr2: {
        required: 'Street house number is required.',
        maxLength: 'Street house number must be within 100 characters.'
      },
      addr3: {
        maxLength: 'Building Name must be within 100 characters.'
      },
      busho: {
        required: 'Department is required.',
        maxLength: 'Department must be within 100 characters.'
      },
      telNo: {
        required: 'Phone number is required.',
        maxLength: 'Phone number must be within 20 characters.'
      },
      remarks: {
        maxLength: 'Remarks must be within 20000 characters.'
      },
      services: {
        required: 'Services requested is required.'
      }
    },
    select: {
      other: 'Other'
    },
    button: {
      change: 'Change'
    },
    desc: {
      text1: ' is required.',
      passwordText1: '- Must be 8 or more characters',
      passwordText2: '- Must be a combination of two or more character types among capital letters, lowercase letters, numbers, and symbols.',
      serviceText: '- If you add a new service that you wish to use, it will become available after the administrator approves it.'
    }
  }

}
